<template>
  <div class="get-temperature-container">
    <div class="heading is-bold">
      Get Temperature Data
    </div>
    <div class="text-blocks">
      <div>
        To get temperature data you will need to use our mobile app
      </div>
      <AppStoreLinks
        @store-click="trackClick"
      />
    </div>
    <Button
      text="Close"
      :on-click="goBack"
      is-text
      has-padding
      is-light
    />
  </div>
</template>

<script>
import Button from '../../components/atoms/button/button';
import AppStoreLinks from '../../components/atoms/links/app-store-links';
import { routeNames } from '../../constants';

export default {
  name: 'DownloadTemperatureRequiresApp',
  components: {
    Button,
    AppStoreLinks,
  },
  props: {
    assetId: { type: String, default: null },
  },
  methods: {
    goBack() {
      if (this.assetId) {
        this.$router.replace({ name: routeNames.assets.detail });
      } else {
        this.$router.replace({ name: routeNames.assets.list });
      }
    },
    trackClick(platform) {
      this.$root.trackEvent.clickAppStoreLink(
        platform,
        'Temperature Download Requires App',
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';
@import '@/styles/_breakpoints.scss';
.get-temperature-container {
  height: 100%;
  background-color: rgba($black, 0.85);
  color: $white;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
  .heading {
    font-size: 1.125rem;
  }
  .text-blocks {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-around;
    padding: 0 20px;
  }
}
</style>
